export const ERROR_NO_BBL = 'Boligbyggelag ikke valgt'
export const ERROR_NO_PAGE_FOUND = 'Ops! Fant ikke siden...'

export const ERROR_IS_NOT_AUTHENTICATED =
  'Ops! Det gikk dessverre ikke å logge deg inn for øyeblikket, prøv igjen ved et senere tilfelle.'

export const ERROR_NO_AUTHORIZATION_NO_CLIENT =
  'Ops! Du har du ikke tilgang til innholdet på denne siden.'
export const ERROR_NO_AUTHORIZATION = (clientName: string) =>
  `Basert på din rolle i ${clientName} har du ikke tilgang til innholdet på denne siden.`
